import { BaseService } from '../base.service';

export class AgenciesService extends BaseService {
  static get resourceEndpoint() {
    return 'owners/agency';
  }
}
